module.exports = __webpack_public_path__ + "static/media/FleetFootwork.52568fad.png";